<template>
  <b-card :title="$t('เเก้ไขข้อมูล') + ` ${huayData.name}`">
    <div v-if="!loaded">
      <!-- 4/5 ตัว: สวิตช์เปิดรายประเภทอยู่ในแถวของตารางอัตราจ่าย ตารางเงื่อนไขล็อก/ปลดล็อกตาม -->
      <LottoRate
        :huay-data="huayData"
        :huay-rate="huayRate"
        :editable-types.sync="fourFiveDigitEditable"
        :four-five-setting.sync="fourFiveDigitSetting"
      />

      <LottoCondition
        class="mt-1"
        :huay-data="huayData"
        :huay-condition="huayCondition"
        :editable-types="fourFiveDigitEditable"
      />

      <b-form-input
        v-model="huayData.externalLink"
        :placeholder="$t('ลิงค์ดูผลรางวัล')"
        class="mt-1 mb-1"
      />

      <editor
        v-model="huayData.raw"
        :init="config"
      />
      <div
        v-if="$can('update', 'lotto.info')"
        class="text-right"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mt-1"
          @click.prevent="save"
        >
          <feather-icon
            icon="SaveIcon"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('Submit') }}</span>
        </b-button>
      </div>

      <h5>
        {{ $t('ตั้งค่าการเปิดปิดอัตโนมัติ') }}
      </h5>

      <b-form-timepicker
        v-model="huayData.start"
        locale="th"
        class="mt-1"
      />

      <b-form-timepicker
        v-model="huayData.end"
        locale="th"
        class="mt-1"
      />

      <div class="demo-inline-spacing">
        <b-form-checkbox
          v-model="huayData.autoDates[0]"
          class="custom-control-danger"
        >
          {{ $t('อาทิตย์') }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="huayData.autoDates[1]"
          class="custom-control-yellow"
        >
          {{ $t('จันทร์') }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="huayData.autoDates[2]"
          class="custom-control-pink"
        >
          {{ $t('อังคาร') }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="huayData.autoDates[3]"
          class="custom-control-success"
        >
          {{ $t('พุธ') }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="huayData.autoDates[4]"
          class="custom-control-warning"
        >
          {{ $t('พฤหัส') }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="huayData.autoDates[5]"
          class="custom-control-info"
        >
          {{ $t('ศุกร์') }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="huayData.autoDates[6]"
          class="custom-control-primary"
        >
          {{ $t('เสาร์') }}
        </b-form-checkbox>
      </div>

      <div
        v-if="$can('update', 'lotto.info')"
        class="text-right"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mt-1"
          @click.prevent="saveTime"
        >
          <feather-icon
            icon="SaveIcon"
            class="mr-50"
          />
          <span class="align-middle">{{ $t('Submit') }}</span>
        </b-button>
      </div>

      <ResultReferenceSettings :huay-id="String($route.query.id || '')" />
    </div>
  </b-card>
</template>

<script>
import ResultReferenceSettings from '@/views/components/ResultReferenceSettings.vue'
import {
  BCard, BButton, BFormTimepicker, BFormInput, BFormCheckbox,
} from 'bootstrap-vue'
import lottoService from '@/service/lottoService'
import { getUserData } from '@/auth/utils'
import fourFiveDigitService, { canManageFourFiveDigit } from '@/service/fourFiveDigitService'
import { BLANK_RATE_ROW, visibleRateRows, withFourFiveDigitRows } from '@/utils/betTypes'
import Editor from '@tinymce/tinymce-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import LottoRate from '@/views/components/LottoRate.vue'
import LottoCondition from '@/views/components/LottoCondition.vue'

export default {
  components: {
    ResultReferenceSettings,
    BCard,
    BButton,
    BFormInput,
    Editor,
    BFormTimepicker,
    BFormCheckbox,
    LottoRate,
    LottoCondition,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      start: '00:00',
      end: '18:00',
      config: {
        height: 600,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount textcolor colorpicker',
        ],
        toolbar:
            'undo redo | formatselect | '
            + ' bold italic backcolor forecolor | alignleft aligncenter '
            + ' alignright alignjustify | bullist numlist outdent indent |'
            + ' removeformat | help',
        content_css: [
          '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
          '//www.tiny.cloud/css/codepen.min.css',
        ],
        images_upload_handler(blobInfo, success) {
          success(
            `data:${blobInfo.blob().type};base64,${blobInfo.base64()}`,
          )
        },
      },
      loaded: true,
      reader: null,
      huayData: {
        name: '',
        externalLink: '',
        raw: '',
        start: '',
        end: '',
        autoDates: [false, false, false, false, false, false, false],
      },
      huayCondition: {},
      huayRate: {},
      // ประเภท 4/5 ตัวที่ติ๊กเปิดในหวยนี้แล้ว · แถวที่เห็นแต่ไม่อยู่ในนี้แก้ไม่ได้
      fourFiveDigitEditable: [],
      // แถวตั้งค่ารายหวย (เฉพาะผู้ที่ตั้งค่าได้) · null = สวิตช์ในตารางแสดงสถานะอย่างเดียว
      fourFiveDigitSetting: null,
    }
  },
  async mounted() {
    this.loaded = true
    const { id } = this.$route.query
    if (id) {
      // สวิตช์รายหวย: อ่านเฉพาะผู้ที่ตั้งค่าได้ พร้อมกันในรอบเดียว
      const [res, res2, fourFiveDigitAccess, fourFiveDigitSettings] = await Promise.all([
        lottoService.getAuthen(`huay/id/${id}`),
        lottoService.getAuthen(`rate/condition/${id}`),
        fourFiveDigitService.settingAccess(),
        canManageFourFiveDigit(getUserData()) ? fourFiveDigitService.huaySettings().catch(() => null) : null,
      ])
      const settingRow = fourFiveDigitSettings && fourFiveDigitSettings.status === 200 && Array.isArray(fourFiveDigitSettings.data)
        ? fourFiveDigitSettings.data.find(v => String(v.id) === String(id))
        : null
      setTimeout(() => {
        if (res.status === 200) {
          const { autoDates } = { ...res.data }
          delete res.data.autoDates
          this.huayData = { ...res.data, autoDates: this.huayData.autoDates }
          if (autoDates !== null && autoDates !== undefined) {
            this.huayData.autoDates = autoDates
          }

          if (this.huayData.raw == null) {
            this.huayData.raw = ''
          }
        }

        if (res2.status === 200) {
          // 4/5 ตัว: ซ่อนประเภทที่ใช้ไม่ได้ · master เห็นแถวว่างของประเภทที่หวยนี้เปิดได้เมื่อเปิดโหมด (แก้ได้เมื่อติ๊กเปิดแล้ว)
          const allowed = fourFiveDigitAccess.visible[id] || []
          const rows = visibleRateRows(res2.data, allowed)
          const withNewRows = this.$store.state.app.isMaster(this.$store)
            ? withFourFiveDigitRows(rows, allowed, { ...BLANK_RATE_ROW, huayId: id })
            : rows
          this.huayCondition = withNewRows
          this.huayRate = withNewRows
        }

        this.fourFiveDigitEditable = fourFiveDigitAccess.editable[id] || []
        // โหมดปิด = ไม่เห็นแถวประเภทใหม่ จึงไม่มีสวิตช์ให้กด
        this.fourFiveDigitSetting = (fourFiveDigitAccess.visible[id] || []).length > 0 && settingRow ? settingRow : null
        this.loaded = false
      }, 100)
    }
  },
  methods: {
    confirmText() {
      this.$swal({
        title: this.$t('Are you sure?'),
        text: this.$t("You won't be able to revert this!"),
        icon: 'warning',
        heightAuto: false,
        showCancelButton: true,
        confirmButtonText: this.$t('Yes, delete it!'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: this.$t('Deleted!'),
            text: this.$t('Your file has been deleted.'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    async save() {
      const { id } = this.$route.query
      if (id) {
        this.$swal({
          dark: true,
          title: this.$t('Are you sure?'),
          text: this.$t('คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่'),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: this.$t('Ok'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.value) {
            const res = await lottoService.putAuthen(
              `huay/id/${id}`,
              {
                externalLink: this.huayData.externalLink,
                raw: this.huayData.raw,
              },
            )
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('บันทึกข้อมูสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          }
        })
      }
    },
    async saveTime() {
      const { id } = this.$route.query
      if (id) {
        this.$swal({
          dark: true,
          title: this.$t('Are you sure?'),
          text: this.$t('คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่'),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: this.$t('Ok'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
          .then(async result => {
            if (result.value) {
              const res = await lottoService.putAuthen(
                `huay/time/${id}?start=${this.huayData.start}&end=${this.huayData.end}`,
                this.huayData.autoDates,
              )
              if (res.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('สำเร็จ'),
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: this.$t('บันทึกข้อมูสำเร็จ'),
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('เกิดข้อผิดพลาด'),
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                    text: res.data,
                  },
                })
              }
            }
          })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';

.custom-control-pink .custom-control-input:checked ~ .custom-control-label::before ,
.custom-control-pink .custom-control-input:active ~ .custom-control-label::before{
  border-color: hotpink !important;
  background-color: hotpink !important;
  box-shadow: 0 2px 4px 0 rgba(255, 192, 203, 0.4) !important;
}

.custom-control-yellow .custom-control-input:checked ~ .custom-control-label::before ,
.custom-control-yellow .custom-control-input:active ~ .custom-control-label::before{
  border-color: rgba(235, 178, 67, 0.99) !important;
  background-color: rgba(235, 178, 67, 0.99) !important;
  box-shadow: 0 2px 4px 0 rgba(255, 178, 67, 0.4) !important;
}

</style>
